// Pruebas corre en *.multytest.com o *.sslip.io; cualquier otro dominio es producción.
const IS_TEST = /(multytest\.com|sslip\.io)$/.test(window.location.hostname);

export const API_BASE_URL = IS_TEST
  ? "https://server.multytest.com"
  : "https://api.multyhealth.com";
export const FILES_BASE_URL = `${API_BASE_URL}/product/get/file`;
export const WEB_BASE_URL = IS_TEST
  ? "https://backoffice.multytest.com"
  : "https://app.multyhealth.com";

// export const API_BASE_URL = "http://localhost:8000";
// export const FILES_BASE_URL = "http://localhost:8000/product/get/file";
// export const WEB_BASE_URL = "http://localhost:3000";

export const CONTRACT_PDF_URL =
  "https://public-files-amzn-multyhealth.s3.us-west-1.amazonaws.com/public/CONTRATO+DE+VINCULACIO%CC%81N+COMERCIAL+DE+VENDEDOR+INDEPENDIENTE+MULTYDRINK.pdf";

// Client ID OAuth (Web) de Google para "Continuar con Google". Es público.
export const GOOGLE_CLIENT_ID =
  "641264823380-02mebg8isneibesml2frsg1fmk84h4q3.apps.googleusercontent.com";
